/**
 * Validation Reducers for RemitSlice
 * 
 * Handles validation error state management.
 */

import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';
import { RemitSliceState } from '../state';

/**
 * Set a validation error for a specific field
 */
export const setValidationError: CaseReducer<
  RemitSliceState,
  PayloadAction<{ field: string; message: string }>
> = (state, action) => {
  state.validationErrors[action.payload.field] = action.payload.message;
};

/**
 * Set multiple validation errors at once
 */
export const setValidationErrors: CaseReducer<
  RemitSliceState,
  PayloadAction<Record<string, string>>
> = (state, action) => {
  state.validationErrors = {
    ...state.validationErrors,
    ...action.payload,
  };
};

/**
 * Clear validation error for a specific field
 */
export const clearValidationError: CaseReducer<
  RemitSliceState,
  PayloadAction<string>
> = (state, action) => {
  delete state.validationErrors[action.payload];
};

/**
 * Clear all validation errors
 */
export const clearAllValidationErrors: CaseReducer<RemitSliceState> = (state) => {
  state.validationErrors = {};
};
